module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "copy"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/PaintItBlack_chap_1"
    }
  }, [_vm._v("Chapter 1: Echo")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/PaintItBlack_chap_2"
    }
  }, [_vm._v("Chapter 2: Pool")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/PaintItBlack_chap_3"
    }
  }, [_vm._v("Chapter 3: Funeral")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_chap_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Cal")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_chap_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: These Days")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_chap_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Otis")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_chap_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Club Rat")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_chap_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Christmas")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_chap_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Meredith")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_chap_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: After")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_chap_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Cemetery")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_chap_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Jeremy")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_chap_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Helms")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_chap_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: Dining Car")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_chap_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Tour")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_chap_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Stripped")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_chap_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: Meredith’s Room")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_chap_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: Goodwill")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_chap_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: Topanga Shoot")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_chap_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: Sweden")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_chap_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: Sunset Plaza")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_chap_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22: Nick")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_chap_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23: Stalked")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_chap_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24: Lotus Room")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_chap_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25: Los Feliz")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_chap_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26: Pen")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_chap_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27: Phone")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_chap_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28: Photo")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_chap_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29: Paris")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_chap_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30: Drown")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_chap_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31: Sofía")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_chap_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 32: Soul")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_chap_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 33: Drive")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_chap_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 34: Paradise")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_chap_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 35: Room 12")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_chap_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 36: Rock")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "ackn_1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_ackn_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "ackn_2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_ackn_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "toc-disxocer"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/discoverpage"
    }
  }, [_vm._v("Discover More Janet Fitch")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "auth_bio_1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/PaintItBlack_auth_bio_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46e83155","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PaintItBlack_toc.vue
// module id = 63
// module chunks = 0